import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { IdleService } from 'src/app/services/idle.service';

@Component({
  selector: 'app-inactivity-warning',
  templateUrl: './inactivity-warning.component.html',
  styleUrls: ['./inactivity-warning.component.scss']
})
export class InactivityWarningComponent {
  constructor(public idleService: IdleService, private authService: AuthService) {}
  countdown$ = this.idleService.countdown$;

  stayLoggedIn() {
    this.idleService.stayLoggedIn();
  }

  logout() {
    this.authService.logout(true);
  }
}
